var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadarIntro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15452_13141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 108,
    height: 108,
    rx: 54,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1445 54.886C49.1414 56.8262 49.9567 58.6777 51.3874 59.9871C52.8181 61.2965 54.7343 61.9464 56.6662 61.7783C58.5982 61.6071 60.3715 60.6371 61.5517 59.0962C62.7349 57.5586 63.214 55.5961 62.8777 53.6844L90.8863 48.7513C91.8857 48.5801 92.7675 47.9936 93.3132 47.1345C93.8557 46.2784 94.0143 45.2322 93.7447 44.2558C90.0425 31.1685 79.8021 20.9471 66.7 17.2697C65.7293 17.0002 64.6855 17.1524 63.8322 17.685C62.9757 18.2208 62.3824 19.0927 62.2016 20.085L57.2654 48.0758C55.2478 47.7112 53.1731 48.2597 51.6027 49.5754C50.0324 50.8911 49.1318 52.8379 49.1445 54.886Z",
    fill: "url(#paint0_linear_15452_13141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0629 92.9902C65.4942 93.0029 74.5989 89.5155 81.6035 83.203C88.6081 76.8908 93.0212 68.2012 93.9787 58.823C94.0897 57.8148 93.763 56.8098 93.0777 56.0617C92.402 55.3103 91.4345 54.8791 90.4225 54.8791C90.2099 54.8791 89.9974 54.8982 89.788 54.9362C88.1859 55.2279 86.9805 56.5594 86.8504 58.1826C86.0288 65.9786 82.2822 73.1755 76.3593 78.3203C70.4397 83.4626 62.7846 86.1701 54.946 85.8974C47.1039 85.6216 39.6585 82.3879 34.1133 76.8431C28.5648 71.2982 25.3293 63.8573 25.0565 56.0204C24.7836 48.1834 27.496 40.5365 32.6448 34.6207C37.7935 28.7048 44.9948 24.9609 52.7986 24.1428C54.6924 23.9621 56.1168 22.3325 56.0376 20.4304C55.9583 18.5282 54.4006 17.0222 52.4972 17H52.1228C39.059 18.3791 27.6226 26.3838 21.8614 38.1847C16.1003 49.9847 16.8237 63.9184 23.7775 75.0594C30.7282 86.2003 42.9323 92.9813 56.0693 93L56.0629 92.9902Z",
    fill: "url(#paint1_linear_15452_13141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8789 40.0672C52.075 39.6361 52.9442 38.593 53.1536 37.3407C53.3344 36.2881 53.0362 35.2102 52.3414 34.4018C51.6752 33.5934 50.6854 33.1242 49.6386 33.1178C49.2452 33.1178 48.855 33.1844 48.4838 33.3144C41.051 35.9109 35.4768 42.1439 33.7258 49.8161C31.9747 57.4883 34.2937 65.5223 39.8612 71.0827C45.4319 76.6435 53.4741 78.9546 61.1479 77.1983C68.8218 75.4419 75.0556 69.8653 77.6471 62.4343C78.0246 61.3691 77.8533 60.1866 77.1934 59.2703C76.5209 58.3192 75.4264 57.7486 74.2621 57.7422C74.0496 57.7454 73.837 57.7644 73.6276 57.7993C72.3745 58.0085 71.3309 58.8772 70.8994 60.0725C69.1165 65.1736 64.8338 69.0002 59.5645 70.2014C54.2952 71.4061 48.7754 69.8177 44.9527 65.9975C41.1301 62.1772 39.5406 56.6607 40.743 51.395C41.9485 46.1258 45.7781 41.8487 50.8789 40.0672Z",
    fill: "url(#paint2_linear_15452_13141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15452_13141",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15452_13141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15452_13141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15452_13141",
    x1: 71.5087,
    y1: 17.1392,
    x2: 55.9995,
    y2: 61.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3428FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#837CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15452_13141",
    x1: 56,
    y1: 17,
    x2: 56,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4B1C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718096",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15452_13141",
    x1: 55.4983,
    y1: 33.1178,
    x2: 55.4983,
    y2: 77.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4B1C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718096",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarIntro);
export default __webpack_public_path__ + "static/media/radar-intro.3e7605398df30ddc633f86d06f464921.svg";
export { ForwardRef as ReactComponent };